import { Hot17Vote, IHot17Vote } from '@/common/models/data/dashboard/hot-17/hot-17-vote'
import { Hot17Entry, IHot17Entry } from '@/common/models/data/dashboard/hot-17/hot-17-entry'

interface IHot17IndexResponse {
    enabled: boolean
    entries: Array<IHot17Entry>
    ip: string
    votes: Array<IHot17Vote>
    voting_phase: boolean
}

class Hot17IndexResponse {
    enabled = false
    entries: Array<Hot17Entry> = []
    ip = ''
    votes: Array<Hot17Vote> = []
    voting_phase = false

    constructor (dto?: IHot17IndexResponse) {
        if (dto) {
            this.enabled = dto.enabled
            this.entries = dto.entries.map(entry => new Hot17Entry(entry))
            this.ip = dto.ip
            this.votes = dto.votes.map(vote => new Hot17Vote(vote))
            this.voting_phase = dto.voting_phase

            const votesCount = this.entries.reduce((acc: number, entry: Hot17Entry) => {
                acc += entry.votes_count

                return acc
            }, 0)

            this.entries.forEach((entry, index) => {
                entry.percentage = entry.votes_count / votesCount * 100
                entry.position = index + 1
            })
        }
    }
}

export {
    IHot17IndexResponse,
    Hot17IndexResponse
}
